import { supabase } from '../client'

export async function getBidsByUserId(userId: number) {
  const { data, error } = await supabase.from('bids').select('*').match({ user_id: userId })

  return { data, error }
}
